import { defaultOrderSortSettingsForList, type OrderSortMode } from "./order-sort";

export type OrderWorkspace = "all" | "size" | "repair";
export type OrderListFilter = "all" | "received" | "shipped" | "hidden" | "unnecessary" | "ended";
export type OrderDashboardView = "active" | "history";
export type ReceiveActionMode = "receive-pdf" | "repair-instock-date";

export interface OrderWorkspaceEntryPlan {
  needsLoad: boolean;
  view: "active";
  filter: "all";
  sortMode: OrderSortMode;
  expressFirst: boolean;
  historyPage: 1;
}

export function orderWorkspaceEntryPlan(
  currentWorkspace: OrderWorkspace,
  nextWorkspace: OrderWorkspace,
  returningFromEtcWorkspace: boolean,
): OrderWorkspaceEntryPlan {
  return {
    needsLoad: currentWorkspace !== nextWorkspace || returningFromEtcWorkspace,
    view: "active",
    filter: "all",
    ...defaultOrderSortSettingsForList(nextWorkspace, "all"),
    historyPage: 1,
  };
}

export function orderFilterView(filter: OrderListFilter): OrderDashboardView {
  return filter === "all" ? "active" : "history";
}

export function receiveActionMode(workspace: OrderWorkspace): ReceiveActionMode {
  return workspace === "repair" ? "repair-instock-date" : "receive-pdf";
}

export function shouldShowShippingRequestAction(
  workspace: OrderWorkspace,
  view: OrderDashboardView,
  filter: OrderListFilter,
): boolean {
  if (workspace === "size") return view === "history" && filter === "received";
  return workspace === "repair" && view === "active";
}

export function shouldShowSizeOrderReprintAction(
  workspace: OrderWorkspace,
  view: OrderDashboardView,
  filter: OrderListFilter,
): boolean {
  return workspace === "size" && view === "history" && filter === "received";
}
